const WhoWeAreSection = () => {
    return (
      <section
        id="who-we-are"
        className="h-screen bg-green-100 flex justify-center items-center"
      >
        <h1 className="text-4xl font-bold text-center">Who We Are Section</h1>
      </section>
    );
  };

  export default WhoWeAreSection;